var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M98.92-847.88l15.51-15.51-3.08-3.08L98.92-854.04l-6.27-6.27-3.08,3.08ZM102-836a21.42,21.42,0,0,1-8.58-1.733,22.215,22.215,0,0,1-6.985-4.7,22.218,22.218,0,0,1-4.7-6.985A21.422,21.422,0,0,1,80-858a21.423,21.423,0,0,1,1.732-8.58,22.217,22.217,0,0,1,4.7-6.985,22.214,22.214,0,0,1,6.985-4.7A21.422,21.422,0,0,1,102-880a21.422,21.422,0,0,1,8.58,1.732,22.214,22.214,0,0,1,6.985,4.7,22.217,22.217,0,0,1,4.7,6.985A21.423,21.423,0,0,1,124-858a21.422,21.422,0,0,1-1.732,8.58,22.218,22.218,0,0,1-4.7,6.985,22.215,22.215,0,0,1-6.985,4.7A21.42,21.42,0,0,1,102-836Z",
    transform: "translate(-80 880)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckHeader);
export default __webpack_public_path__ + "static/media/checkHeader.1c97515b2ea82de985d5d5fa2d821cbe.svg";
export { ForwardRef as ReactComponent };